import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Sitemap = () => {
  const [dropdown, setDropdown] = useState([]);

  // Load saved data when component mounts
  useEffect(() => {
    const storedData = localStorage.getItem("dropdown");

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        setDropdown(parsedData);
        console.warn("Parsed Data:", parsedData);
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
        setDropdown([]);
      }
    }
  }, []);

  return (
    <>
      <Header />
      <div className="full-div mt-5" id="blog">
        <Container fluid className="main-sec">
          <Row>
            <input type="hidden" value="7" className="fetchlimit" />
            <input type="hidden" value="5" className="fetchlimitright" />

            <Col sm={2}></Col>

            <Col sm={7} className="bg-white p-4 div-shadow mb-3">
              <h1 className="text-center head-color">Sitemap</h1>
              <ul className="text-dark">
                <li><a href="/">Home</a></li>
                <li><a href="/about">About Us</a></li>
                <li>
                  <a href="#">Blog</a>
                  <ul className="">
                    {dropdown.length > 0 ? (
                      dropdown.map((item, index) => (
                        <li key={index}><Link to={`/${item.route}`}>{item.name}</Link></li>
                      ))
                    ) : (
                      <li>No data Found</li>
                    )}
                  </ul>
                </li>
                <li><a href="/contactus.html">Contact Us</a></li>
                <li><a href="/privacy.html">Privacy Policy</a></li>
                <li><a href="/terms.html">Terms & Condition</a></li>
                <li><a href="/disclaimer.html">Disclaimer</a></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Sitemap;
